module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-orderSummary"
  }, [_c('OrderDetails', {
    ref: "order",
    attrs: {
      "title": "Order summary"
    }
  }), _vm._v(" "), _c('CartCoupon', {
    ref: "CartCoupon",
    staticClass: "o-orderSummary__couponCode"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dfe8f1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/organisms/OrderSummary.vue
// module id = 544
// module chunks = 2